import React from 'react';
import LoginBox from '../../components/auth/LoginBox';

const Login: React.FC = () => {
  return (
    <main className="login-page">
      <LoginBox />
    </main>
  );
};

export default Login;
